import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MutedOutlinedSvg from "@ant-design/icons-svg/es/asn/MutedOutlined";
import AntdIcon from '../components/AntdIcon';
var MutedOutlined = function MutedOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: MutedOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(MutedOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'MutedOutlined';
}
export default RefIcon;